import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from './../../app.component';

@Component({
  selector: 'simulator-component',
  templateUrl: './simulator.component.html'
})

export class SimulatorComponent {
  costs: any = {
    cine: null,
    academy: null,
    medicines: null,
    school: null,
    restaurants: null,
    courses: null
  };
  economyValue: any = 287;
  identifyPage: string = 'you';

  // Default values
  valueRangeCine: string = '30% 100%';
  valueRangeAcademy: string = '4% 100%';
  valueRangeCourses: string = '4% 100%';
  valueRangeMedicines: string = '8% 100%';
  valueRangeSchool: string = '3% 100%';
  valueRangeRestaurants: string = '30% 100%';

  constructor(public router: Router, public appComponent: AppComponent) {
    this.costs = {
      cine: 6,
      academy: 20,
      medicines: 150,
      school: 200,
      restaurants: 600,
      courses: 200
    }
  }

  getEconomyValues(val, e?): void {

    let valueRange = (e.target.value - e.target.min) * 100 / (e.target.max - e.target.min) + '% 100%';
    let nameRange = e.target.name;

    switch (nameRange) {
      case "cine":
        this.valueRangeCine = valueRange;
        break;
      case "academy":
        this.valueRangeAcademy = valueRange;
        break;
      case "courses":
        this.valueRangeCourses = valueRange;
        break;
      case "medicines":
        this.valueRangeMedicines = valueRange;
        break;
      case "school":
        this.valueRangeSchool = valueRange;
        break;
      case "restaurants":
        this.valueRangeRestaurants = valueRange;
        break;
      
      default:
        break;
    }

    let cine = parseInt(val.cine) || 0;
    let academy = parseFloat(val.academy) || 0;
    let courses = parseFloat(val.courses) || 0;
    let medicines = parseFloat(val.medicines) || 0;
    let school = parseFloat(val.school) || 0;
    let restaurants = parseFloat(val.restaurants) || 0;

    // Economy calculation
    let economy = this.calculateEconomy(cine, academy, courses, medicines, school, restaurants);
    this.economyValue = economy.toString().slice(0,6);
  }

  calculateEconomy(cine, academy, courses, medicines, school, restaurants): number {
    let discount_cine = cine*17;
    let discount_academy = academy*25/100;
    let discount_courses = courses*25/100;
    let discount_medicines = medicines*20/100;
    let discount_school = school*20/100;
    let discount_restaurante = restaurants*10/100;

    return discount_cine + discount_courses + discount_academy + discount_medicines + discount_school + discount_restaurante;
  }

}
